<!-- eslint-disable max-len -->
<template>
  <section class="hero">
    <dt-stack
      direction="row"
      justify="between"
      align="center"
      class="hero__inner-wrapper d-mx-auto d-wmx1340 d-pl24 d-pr32"
    >
      <dt-stack justify="center" class="hero__content">
        <h1 class="d-headline--xxl d-mb12 d-ff-marketing">
          Improve your UI's reception with Dialtone
        </h1>
        <p class="d-fs-300 d-lh-400 d-mb16 d-fc-secondary">
          Documented styles, components, and utility classes to help you quickly design and build unified experiences
          across Dialpad experiences.
        </p>
        <dt-stack direction="row" justify="start" class="d-mb32">
          <a
            class="d-td-unset d-d-inline-flex"
            href="https://github.com/dialpad/dialtone"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              alt="Dialtone version number"
              src="https://img.shields.io/npm/v/@dialpad/dialtone?color=F5F0FF&label=Dialtone"
            >
          </a>
        </dt-stack>
        <dt-stack direction="row" justify="center" gap="500">
          <dt-button
            to="/guides/getting-started/"
            size="lg"
            @click="sendAnalyticsEvent()"
          >
            Get Started
          </dt-button>
          <dt-button
            to="/about/whats-new/"
            size="lg"
            importance="outlined"
          >
            What's New?
          </dt-button>
        </dt-stack>
      </dt-stack>
      <svg-loader class="hero__image d-w50p" name="home-billboard" />
    </dt-stack>
  </section>
  <section class="links d-bt d-bb d-bc-subtle d-bgc-secondary">
    <div class="d-d-grid d-gg16 d-g-cols12 d-wmx1340 d-mx-auto">
      <dt-stack gap="400" class="link d-body--md d-gc3 d-px32 d-ta-center">
        <router-link class="d-fc-primary h:d-td-underline d-td-none d-bar8 d-pt4" to="/design/">
          <dt-stack gap="600">
            <svg-loader class="d-h96" name="home-design-language" />
            <h2 class="d-headline--xl d-ff-marketing">
              Design Language
            </h2>
          </dt-stack>
        </router-link>
        <p class="d-body--md-compact d-fc-secondary">
          Foundational color, iconography, and spacing guidelines
        </p>
        <dt-stack gap="300">
          <dt-link to="/design/">
            Browse Design Guidelines
          </dt-link>
        </dt-stack>
      </dt-stack>
      <dt-stack gap="400" class="link d-body--md d-gc3 d-px32 d-ta-center">
        <router-link class="d-fc-primary h:d-td-underline d-td-none d-bar8 d-pt4" to="/components/">
          <dt-stack gap="600">
            <svg-loader class="d-h96" name="home-components" />
            <h2 class="d-headline--xl d-ff-marketing">
              Components
            </h2>
          </dt-stack>
        </router-link>
        <p class="d-body--md-compact d-fc-secondary">
          Presentational UI components offered in CSS and Vue
        </p>
        <dt-stack gap="300">
          <dt-link to="/components/">
            Browse CSS Components
          </dt-link>
          <dt-link href="https://dialtone.dialpad.com/vue/index.html?path=/docs/welcome--docs" target="_blank" rel="noopener noreferrer">
            Browse Vue Components
          </dt-link>
        </dt-stack>
      </dt-stack>
      <dt-stack gap="400" class="link d-body--md d-gc3 d-px32 d-ta-center">
        <router-link class="d-fc-primary h:d-td-underline d-td-none d-bar8 d-pt4" to="/utilities/">
          <dt-stack gap="600">
            <svg-loader class="d-h96" name="home-utilities" />
            <h2 class="d-headline--xl d-ff-marketing">
              Utilities
            </h2>
          </dt-stack>
        </router-link>
        <p class="d-body--md-compact d-fc-secondary">
          A utility-first CSS framework for building user interfaces.
        </p>
        <dt-stack gap="300">
          <dt-link to="/utilities/">
            Browse Utility Classes
          </dt-link>
        </dt-stack>
      </dt-stack>
      <dt-stack gap="400" class="link d-body--md d-gc3 d-px32 d-ta-center">
        <router-link class="d-fc-primary h:d-td-underline d-td-none d-bar8 d-pt4" to="/guides/">
          <dt-stack gap="600">
            <svg-loader class="d-h96" name="home-guides" />
            <h2 class="d-headline--xl d-ff-marketing">
              Guides
            </h2>
          </dt-stack>
        </router-link>
        <p class="d-body--md-compact d-fc-secondary">
          Reference guidelines for Accessibility, Writing, and more
        </p>
        <dt-stack gap="300">
          <dt-link to="/guides/getting-started/">
            Getting Started
          </dt-link>
          <dt-link to="/guides/content/">
            Writing Guidelines
          </dt-link>
          <dt-link to="/guides/accessibility/">
            Accessibility
          </dt-link>
        </dt-stack>
      </dt-stack>
    </div>
  </section>
  <section class="d-py64 d-ta-center">
    <dt-stack direction="row" gap="500" align="center" class="d-fc-secondary d-px48 d-mx-auto d-d-inline-flex">
      <h2 class="d-headline--lg d-fw-semibold">
        Don't see something? Want to contribute?
      </h2>
      <dt-button
        href="https://dialpad.atlassian.net/servicedesk/customer/portal/123/create/465"
        target="_blank"
        rel="noopener noreferrer"
        kind="muted"
        importance="outlined"
        size="lg"
      >
        Make a request
      </dt-button>
      <dt-button
        href="https://dialpad.atlassian.net/secure/CreateIssue.jspa?issuetype=1&pid=12508"
        target="_blank"
        rel="noopener noreferrer"
        kind="muted"
        importance="outlined"
        size="lg"
      >
        Report a bug
      </dt-button>
    </dt-stack>
  </section>
</template>

<script setup>
function sendAnalyticsEvent () {
  if (!window.gtag) return;
  window.gtag('event', 'click', { event_name: 'get_started_button_clicked' });
}
</script>
